<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [areaName]="areaName"
  [columns]="columns"
  secondClass="main-page"
  [isShowModal]="false"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-select
      name="BankId"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Portal.Rahkaran.BankID' | translate"
      userClass="select-sm"
      apiName="Rahkaran/BankAccountById"
      valueFieldName="ID"
      textFieldName="BankName"
      textColumnsName="BankName,BankBranchTitle"
      filterKey="BankName,BankBranchTitle"
      IsLookup="true"
      DisplayMember="GeneralLedgerTitle"
      [columnsTitleName]="'ClientApp.FrontOffice.Portal.Rahkaran.BranchName' | translate"
      [isMultiColumns]="true"
      SortColumn="ID">
    </ssg-select>

    <ssg-select
      name="CashId"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Portal.Rahkaran.Box' | translate"
      userClass="select-sm"
      apiName="Rahkaran/GetAllCashes"
      valueFieldName="ID"
      textFieldName="Title"
      textColumnsName="Title"
      filterKey="Title"
      IsLookup="true"
      DisplayMember="GeneralLedgerTitle"
      [columnsTitleName]="'ClientApp.FrontOffice.Portal.Rahkaran.Box' | translate"
      [isMultiColumns]="true"
      SortColumn="ID">
    </ssg-select>

    <ssg-select
      name="AccountingOperationId"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Portal.Rahkaran.Box' | translate"
      userClass="select-sm"
      apiName="Rahkaran/CashFlowFactortById"
      valueFieldName="ID"
      textFieldName="Title"
      textColumnsName="Title"
      filterKey="Title"
      IsLookup="true"
      DisplayMember="GeneralLedgerTitle"
      [columnsTitleName]="'ClientApp.FrontOffice.Portal.Rahkaran.Operation' | translate"
      [isMultiColumns]="true"
      SortColumn="ID">
    </ssg-select>

    <ssg-select
      name="CashFlowFactorId"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Portal.Rahkaran.Operation' | translate"
      userClass="select-sm"
      apiName="Rahkaran/AccountingOperationById"
      valueFieldName="ID"
      textFieldName="Title"
      textColumnsName="Title"
      filterKey="Title"
      IsLookup="true"
      DisplayMember="GeneralLedgerTitle"
      [columnsTitleName]="'ClientApp.FrontOffice.Portal.Rahkaran.CashFlowOperations' | translate"
      [isMultiColumns]="true"
      SortColumn="ID">
    </ssg-select>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      buttontype="button"
      class="btn-footer"
      [label]="'ClientApp.FrontOffice.Portal.Rahkaran.GetInformation' | translate"
      appearance="flat"
      (click)="GetProductInfo()">
    </ssg-button>
  </ng-container>
</dynamic-form>
